import type { MouseEvent } from 'react';

export function shouldNavigate(event: MouseEvent<HTMLAnchorElement>): boolean {
  return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.currentTarget.hasAttribute('download') && (!event.currentTarget.target || event.currentTarget.target === '_self');
}
